import { Formik, Form, getIn } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { PulseLoader } from "react-spinners";
import FormControl from "components/global/form/FormControl";
import { create_installments } from 'redux/actions/installmentActions';
import MultiSelect from './inputinstallment/MultiSelect';
import InputDate from 'components/payinstallment/inputinstallment/inputDate';
import { useParams } from "react-router-dom";
import * as Yup from "yup";
import toast from "react-hot-toast";
import InstallmentCard   from './inputinstallment/InstallmentCard';

const validationSchema = Yup.object().shape({
  mainAmount: Yup.number()
    .required("Total Amount is required")
    .min(1, "Total Amount must be greater than 0"),

  receiptDate: Yup.date().required("Receipt date is required"),

  // receiptNo: Yup.number()
  //   .required("Receipt No is required"),

  parts: Yup.array()
    .of(
      Yup.object().shape({
        amount: Yup.number()
          .required("Amount is required")
          .min(1, "Amount must be greater than 0"),

        paidAt: Yup.date()
          .required("Paid date is required"),
        reference: Yup.string().nullable()
      })
    )
    .min(1, "At least one payment method is required"),

  notes: Yup.string().nullable(),
  files: Yup.array()
}).test("parts-total", "Payment parts must equal the installment payment", function (values) {
  const total = (values?.parts || []).reduce((sum, part) => sum + Number(part.amount || 0), 0);
  if (Math.abs(total - Number(values?.mainAmount || 0)) <= 0.01) return true;
  return this.createError({ path: "mainAmount", message: "Payment parts must equal the installment payment" });
});



const PayInstallmentForm = () => {
  const { id } = useParams();


  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { createLoading,doc } = useSelector((state) => state.installment);






const getToday = () => {
  const today = new Date();
  const pad = (value) => String(value).padStart(2, "0");
  return `${today.getFullYear()}-${pad(today.getMonth() + 1)}-${pad(today.getDate())}`;
};

const initValues = {
  mainAmount: doc ? Math.max(Number(doc.amount || 0) - Number(doc.paidAmount || 0), 0) : '',
  receiptNo: '',
  receiptDate: getToday(),
  parts: [],
  notes: "",
  files: [],
};



  const validateForm = async (values) => {
    try {
      await validationSchema.validate(values, { abortEarly: false });
      return {};
    } catch (err) {
      const errors = {};

      err.inner.forEach((e) => {
        errors[e.path] = e.message;
        toast.error(e.message);
      });

      return errors;
    }
  };

  const formatDate = (value) => {
    if (!value) return "";

    // Date inputs store calendar dates as YYYY/MM/DD or YYYY-MM-DD. Build the
    // timestamp in UTC so converting to ISO cannot shift the selected day.
    const dateOnly = String(value).match(/^(\d{4})[-/](\d{2})[-/](\d{2})$/);
    if (dateOnly) {
      const [, year, month, day] = dateOnly;
      return new Date(Date.UTC(Number(year), Number(month) - 1, Number(day))).toISOString();
    }

    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? value : date.toISOString();
  };


  // const distributeAmounts = (selectedMethods, mainAmount, currentParts = []) => {
  //   if (!mainAmount || selectedMethods.length === 0) return [];

  //   const amountPerMethod = (parseFloat(mainAmount) / selectedMethods.length).toFixed(2);

  //   return selectedMethods.map(method => {
  //     const existingPart = currentParts.find(part => part.method === method);

  //     return {
  //       method: method,
  //       amount: amountPerMethod, 
  //       paidAt: existingPart ? existingPart.paidAt : "",
  //       reference: existingPart ? existingPart.reference : "",
  //     };
  //   });
  // };


const handleMethodSelect = (selectedMethod, formik) => {
  const exists = formik.values.parts.some(
    (p) => p.method === selectedMethod.value
  );

  if (!exists) {
    const newPart = {
      method: selectedMethod.value,
      amount: "",
      paidAt: "",
      reference: "",
    };
    formik.setFieldValue("parts", [...formik.values.parts, newPart]);
  }
};

const handleMethodRemove = (removedMethod, formik) => {
  const filteredParts = formik.values.parts.filter(
    (p) => p.method !== removedMethod.value
  );
  formik.setFieldValue("parts", filteredParts);
};

const handleMainAmountChange = (e, formik) => {
  formik.handleChange(e);
};

  const handleSubmit = async (values, { resetForm }) => {
    const errors = await validateForm(values);

    if (Object.keys(errors).length > 0) {
      return; 
    }

    try {
      const formattedValues = {
        installment: id,
        receiptNo: values?.receiptNo?.toString() || "",
        receiptDate: formatDate(values.receiptDate),
        totalAmount: Number(values?.mainAmount),
        parts: values.parts.map(p => ({
          method: p.method,
          amount: Number(p.amount),
          paidAt: formatDate(p.paidAt),
          reference: p.reference || "",
        })),
        notes: values.notes || "",
        files: values.files || []
      };

      console.log("Submitted Values:", formattedValues);
      await dispatch(create_installments(formattedValues, navigate));
      resetForm();
    } catch (error) {
      // The action displays the API error; keep the entered values for correction.
    }
  };

  const paymentOptions = [
    { label: "Online Transfer", value: "online_transfer" },
    { label: "Cheque", value: "cheque" },
    { label: "Cheque1", value: "cheque1" },
    { label: "Cheque2", value: "cheque2" },
    { label: "Cheque3", value: "cheque3" },
    { label: "Pay Order", value: "pay_order" },
    { label: "Cash", value: "cash" },
    { label: "Other", value: "other" },
  ];
const parseNumber = (value = "") =>
  value.replace(/,/g, "").replace(/[^\d.]/g, "");

const formatNumber = (value) => {
  if (value === "" || value === null || value === undefined) return "";
  const raw = String(value).replace(/,/g, "");
  if (raw === "" || raw === ".") return raw;

  const [intPart, decPart] = raw.split(".");
  const intFormatted = Number(intPart || 0).toLocaleString("en-US");
  return decPart !== undefined ? `${intFormatted}.${decPart}` : intFormatted;
};
  return (
    <div className="w-full flex flex-col gap-6 px-3 pb-4">
      <Formik
        initialValues={initValues}
        onSubmit={handleSubmit}
          enableReinitialize={true}
      >
        {(formik) => (
          <Form className="flex flex-col gap-6">
            <div className="flex flex-col gap-5 px-3 w-full">
              <div className="w-full grid grid-cols-1 sm:grid-cols-2 gap-5  pt-8">
                <FormControl
                  control="input"
                  type="text"
                  label="Installment Payment"
                  name="mainAmount"
                  formik={formik}
                  value={formatNumber(formik.values.mainAmount)}
                  autoComplete="off"
                  autoCapitalize="off"
                  readOnly={true}
                  spellCheck={false}

                                    onChange={(e) => handleMainAmountChange(e, formik)}

                />
                <FormControl control="input" type="text" label="Receipt No" name="receiptNo" formik={formik} autoComplete="off" autoCapitalize="off" spellCheck={false} />
                <InputDate label="Receipt Date" name="receiptDate" formik={formik} dateSeparator="-" />

                <MultiSelect
                  label="Payment Method"
                  name="parts"
                  formik={formik}
                  options={paymentOptions}
                  onSelect={(selectedMethod) => handleMethodSelect(selectedMethod, formik)}
                  onRemove={(removedMethod) => handleMethodRemove(removedMethod, formik)}
                />
              </div>


              {formik.values.parts?.map((part, index) => (
                <div key={index} className="w-full grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-5 mt-4">
                  <FormControl
                    control="input"
                    type="text"
                    label="Paid By"
                    name={`parts[${index}].method`}
                    formik={formik}
                    value={getIn(formik.values, `parts[${index}].method`)}
                    onChange={formik.handleChange}
                    readOnly
                  />
                  <FormControl
                    control="input"
                    type="text"
                    label="Reference #"
                    name={`parts[${index}].reference`}
                    formik={formik}
                    value={getIn(formik.values, `parts[${index}].reference`)}
                    onChange={formik.handleChange}
                  />
                   <FormControl
                      control="input"
                      type="text" 
                      inputMode="decimal"
                      label="Paid Amount"
                      name={`parts[${index}].amount`}
                      formik={formik}
                      value={formatNumber(getIn(formik.values, `parts[${index}].amount`))}
                      onChange={(e) =>
                        formik.setFieldValue(
                          `parts[${index}].amount`,
                          parseNumber(e.target.value)
                        )
                      }
                      onBlur={formik.handleBlur}
                      step="0.01"
                    />
                  {/* <FormControl
                    control="input"
                    type="number"
                    label="Paid Amount"
                    name={`parts[${index}].amount`}
                    formik={formik}
                    value={getIn(formik.values, `parts[${index}].amount`)}
                    onChange={formik.handleChange}
                    step="0.01"
                  /> */}
                  <InputDate
                    label="Paid Date"
                    name={`parts[${index}].paidAt`}
                    formik={formik}
                    // value={getIn(formik.values, `parts[${index}].paidAt`)}
                    onChange={formik.handleChange}
                  />
                </div>
              ))}
                            <InstallmentCard  doc={doc}/>



              <FormControl
              control="textarea"
              type="text"
              label="Notes"
              name="notes"
              formik={formik}
            />
            <FormControl
              control="multi-file-base64"
              label="Add Files (Optional)"
              name="files"
              formik={formik}
              minWidth={800}
              minHeight={600}
            />

            </div>

            
            {/* Buttons */}
            <div className="px-3 w-full flex justify-center">
              <div className="flex items-center gap-2">
                <button type="button" className="btn-secondary text-sm xs:text-base w-fit md:w-[148px]" onClick={() => formik.resetForm()}>
                  Clear
                </button>
                <button 
  type="submit" 
  className="btn-primary py-2 xl:px-12 px-6 text-sm xs:text-base w-fit" 
  disabled={createLoading}
>
  {createLoading ? (
    <PulseLoader size={12} color='white' />
  ) : (
    "Submit"
  )}
</button>

              
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default PayInstallmentForm;
